import { DefaultValues } from "react-hook-form";
import * as yup from "yup";
import { generateRandomHexColor } from "../../../../common/infrastructure/utilities/colorUtility";

export const serviceTypeSchema = yup
  .object({
    id: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .optional(),
    name: yup.string().required("Името е задължително").defined(),
    description: yup.string().optional(),
    color: yup.string().required("Цветът е задължителен").defined(),
    durationInMinutes: yup
      .number()
      .required("Продължителността е задължителна")
      .min(5, "Минимум 5 минути")
      .max(480, "Максимум 8 часа")
      .defined(),
    bufferAfterMinutes: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? 0 : value
      )
      .required()
      .min(0, "Буферът не може да бъде отрицателен")
      .max(120, "Максимум 120 минути")
      .defined(),
    allowOnlineBooking: yup.boolean().required().defined(),
    // Remote appointment: Planny creates a Google Meet link from the owner's Google account.
    isRemote: yup.boolean().required().defined(),
    employeeIds: yup
      .array()
      .of(yup.number().required())
      .required("Изберете поне един служител")
      .defined(),
    isPriceRange: yup.boolean().required().defined(),
    minPrice: yup
      .number()
      .required("Минималната цена е задължителна")
      .min(0, "Цената не може да бъде отрицателна")
      .defined(),
    maxPrice: yup
      .number()
      .required("Максималната цена е задължителна")
      .min(0, "Цената не може да бъде отрицателна")
      .test(
        "max-greater-than-min",
        "Максималната цена трябва да бъде по-голяма или равна на минималната",
        function (value) {
          const { minPrice } = this.parent;
          return value >= minPrice;
        }
      )
      .defined(),
    isDeleted: yup.boolean().optional(),
    hallId: yup.number().positive().min(0).nullable().defined(),
    categoryId: yup.number().positive().min(0).nullable().defined(),
    preReservationFormId: yup.number().positive().min(0).nullable().defined(),
    sortOrder: yup.number().optional(),
  })
  .required();

export type IServiceTypeInputModel = yup.InferType<typeof serviceTypeSchema>;

export const getServiceTypeDefaults =
  (): DefaultValues<IServiceTypeInputModel> => ({
    name: "",
    description: "",
    color: generateRandomHexColor(),
    durationInMinutes: 60,
    bufferAfterMinutes: 0,
    allowOnlineBooking: true,
    isRemote: false,
    isPriceRange: false,
    minPrice: 0,
    maxPrice: 0,
    employeeIds: [],
    hallId: null,
    categoryId: null,
    preReservationFormId: null,
  });
